import { useTranslation } from "react-i18next";

export default function RecommendedNewLabel(props) {
    const { isSpecial, isNew } = props;

    const { t } = useTranslation();

    if (isSpecial) {
        return <div className="w-1/2 px-3 rounded-t-lg font-bold text-base text-center bg-yellow-500">{t("dish.div_1")}</div>;
    }

    if (isNew) {
        return <div className="w-1/2 px-3 rounded-t-lg font-bold text-base text-center bg-mycia-orange">{t("newlabel.div_1")}</div>;
    }

    return null;

}
